import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * SubscriptionGuard
 *
 * Avvolge tutte le route /app/*.
 * Se subscription_status = 'canceled' → reindirizza a /paywall (che mostra il modal di pagamento).
 * I demo account bypassano sempre il guard.
 */
const SubscriptionGuard = ({ children }) => {
    const { organization, isDemoAccount, loading } = useAuth();
    const navigate = useNavigate();

    const isCanceled = !loading && !isDemoAccount && organization?.subscription_status === 'canceled';

    useEffect(() => {
        if (isCanceled) {
            navigate('/paywall', { replace: true });
        }
    }, [isCanceled, navigate]);

    // Non bloccare mentre il profilo/org sta caricando
    if (loading) return children;

    // Demo account: nessun paywall
    if (isDemoAccount) return children;

    // Se canceled: render null mentre avviene il redirect
    if (isCanceled) return null;

    return children;
};

export default SubscriptionGuard;
